import {View, StyleSheet} from 'react-native';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import LinearGradient from '@/components/basic/linear-gradient';
import {Shadow, ShadowProps} from 'react-native-shadow-2';
import {toPriceStr, useResponsiveDimensions} from '@/utils';
export interface BetsPricesProps {
  prices?: number[];
  selectedPrice?: number;
  onSelect?: (price: number) => void;
}

const BetsPrices = ({
  prices = [],
  selectedPrice = 10,
  onSelect,
}: BetsPricesProps) => {
  const ShadowPresets = {
    button: {
      distance: 0,
      startColor: '#C3C8DC',
    } as ShadowProps,
  };

  const {width} = useResponsiveDimensions();

  return (
    <View style={[theme.flex.row, styles.gap]}>
      {prices.map((item, index) => {
        const isSelected = selectedPrice === item;
        return (
          <NativeTouchableOpacity
            key={index}
            onPress={() => onSelect && onSelect(item)}>
            <Shadow
              offset={isSelected ? [0, 0] : [0, 2]}
              {...ShadowPresets.button}>
              <LinearGradient
                colors={
                  isSelected
                    ? [theme.basicColor.primary, theme.basicColor.primary]
                    : ['#F2F4F9', '#F3F5FB']
                }
                style={[
                  theme.flex.center,
                  theme.borderRadius.xs,
                  // eslint-disable-next-line react-native/no-inline-styles
                  {
                    width:
                      (width - 40 - 8 * (prices.length - 1)) / prices.length,
                    height: 40,
                  },
                ]}>
                <Text
                  size="medium"
                  fontFamily="fontInterBold"
                  color={
                    isSelected ? theme.basicColor.white : theme.basicColor.dark
                  }>
                  {toPriceStr(item, {
                    fixed: 0,
                  })}
                </Text>
              </LinearGradient>
            </Shadow>
          </NativeTouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  gap: {
    gap: 8,
  },
  item: {
    height: 40,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.50)',
  },
});

export default BetsPrices;
